import React, { useState } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { Inicio } from '../pages/Inicio'
import { Login } from '../pages/Login';
import PrivateRoute from './PrivateRoute';
import { Footer } from '../components/Footer';



export const Router = () => {
    //-----------------------------------------------------------------------------------------------v1.0.2--------------------------------------------------------------------------------------------

    const theme = createTheme({
        palette: {
            mode: 'light',
            background: {
                default: '#faf9f9',
                paper: '#ffffff',
            },
            primary: {
                main: '#710008',
                light: '#941b1b',
                dark: '#410003',
                contrastText: '#ffffff'
            },
            secondary: {
                main: '#bb0013',
                light: '#e71520',
                dark: '#93000d',
                contrastText: '#ffffff'
            },
            tertiary: {
                main: '#333536',
                light: '#4a4c4c',
                dark: '#1a1c1c',
                contrastText: '#ffffff'
            },
            error: {
                main: '#ba1a1a',
                light: '#ffdad6',
                dark: '#93000a',
                contrastText: '#ffffff'
            },
            text: {
                primary: '#1b1c1c',
                secondary: '#59413e',
            },
            divider: '#e0bfbb',
            azul: {
                main: '#710008',
                light: '#941b1b',
                dark: '#410003',
                contrastText: '#ffffff'
            },
            naranja: {
                main: '#bb0013',
                light: '#e71520',
                dark: '#93000d',
                contrastText: '#ffffff'
            },
            blanco: {
                main: '#faf9f9',
                light: '#ffffff',
                dark: '#e3e2e2',
                contrastText: '#1b1c1c'
            },
            negro: {
                main: '#1b1c1c',
                light: '#303031',
                dark: '#000000',
                contrastText: '#f2f0f0'
            },
            verde: {
                main: '#33b13d',
                light: '#33b13d',
                dark: '#33b13d',
                contrastText: '#F6F5F5'
            },
            rojo: {
                main: '#bb0013',
                light: '#e71520',
                dark: '#93000d',
                contrastText: '#ffffff'
            },
            morado: {
                main: '#4a4c4c',
                light: '#bbbcbc',
                dark: '#333536',
                contrastText: '#ffffff'
            },
            gris: {
                main: '#8c706d',
                light: '#e3e2e2',
                dark: '#59413e',
                contrastText: '#ffffff'
            },
        },
        typography: {
            fontFamily: '"Roboto", "Arial", sans-serif',
            h1: {
                fontFamily: '"Roboto Flex", "Roboto", "Arial", sans-serif',
                fontSize: '36px',
                fontWeight: 700,
                lineHeight: 1.2,
                letterSpacing: 0,
            },
            h4: {
                fontFamily: '"Roboto Flex", "Roboto", "Arial", sans-serif',
                fontSize: '24px',
                fontWeight: 600,
                lineHeight: 1.3,
                letterSpacing: 0,
            },
            h6: {
                fontFamily: '"Roboto Flex", "Roboto", "Arial", sans-serif',
                fontSize: '18px',
                fontWeight: 600,
                lineHeight: 1.3,
                letterSpacing: 0,
            },
            body1: {
                fontFamily: '"Roboto", "Arial", sans-serif',
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: 1.5,
                letterSpacing: 0,
            },
            body2: {
                fontFamily: '"Roboto", "Arial", sans-serif',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: 1.5,
                letterSpacing: 0,
            },
            caption: {
                fontFamily: '"Roboto Condensed", "Roboto", "Arial", sans-serif',
                fontSize: '12px',
                fontWeight: 500,
                lineHeight: 1.2,
                letterSpacing: '0.05em',
                textTransform: 'uppercase',
            },
            button: {
                fontFamily: '"Roboto Flex", "Roboto", "Arial", sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                lineHeight: 1,
                letterSpacing: 0,
                textTransform: 'none',
            },
        },
        shape: {
            borderRadius: 8,
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: 8,
                        boxShadow: 'none',
                        minHeight: 44,
                    },
                    contained: {
                        '&:hover': {
                            boxShadow: 'none',
                        },
                    },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        borderRadius: 8,
                        backgroundColor: '#ffffff',
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#710008',
                            boxShadow: '0 0 0 2px rgba(113, 0, 8, 0.15)',
                        },
                    },
                    notchedOutline: {
                        borderColor: '#8c706d',
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        fontFamily: '"Roboto Condensed", "Roboto", "Arial", sans-serif',
                        fontSize: '12px',
                        fontWeight: 500,
                        letterSpacing: '0.05em',
                        textTransform: 'uppercase',
                        color: '#59413e',
                    },
                },
            },
        }
    });
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    return (
        <BrowserRouter>
            <div className='outfit load' style={{ width: '100%', minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'stretch' }}>

                <ThemeProvider theme={theme}>
                    <Routes>
                        <Route element={<PrivateRoute />}>
                            <Route path='*' element={<Inicio />} ></Route>
                            <Route path='/' element={<Inicio />} ></Route>
                            <Route path='/inicio' element={<Inicio />} ></Route>

                            {/* <Route path='/centros/:idERPCliente' element={<Proyectos />} ></Route> */}

                        </Route>

                        <Route path="*" element={<Navigate to="/" replace />} />
                        <Route path='/login' element={<Login username={username} setUsername={setUsername} password={password} setPassword={setPassword} />} ></Route>

                    </Routes>

                    <Footer />

                </ThemeProvider>

            </div>
        </BrowserRouter>
    )
}
